import dantmsConfigs from './dantms';
import defaultConfigs from './default';

export default {
  ...defaultConfigs,
  ...(window.DOMAIN === 'dantms.com' ? dantmsConfigs : {}),
};
